/** Primary pointer button (left click / touch contact). */
export function isPrimaryPointerButton(button: number): boolean {
  return button === 0;
}

/** Whether a pointer-up should trigger ring segment selection (not a drag). */
export function shouldHandleRingSegmentPointerUp(
  pointerDownTarget: EventTarget | null,
  pointerUpTarget: EventTarget | null,
): boolean {
  if (!pointerDownTarget || !pointerUpTarget) return false;
  return pointerDownTarget === pointerUpTarget;
}

type ClosestCapable = { closest(selector: string): Element | null };

function asClosestCapable(target: EventTarget | null): ClosestCapable | null {
  if (!target || typeof (target as unknown as ClosestCapable).closest !== "function") return null;
  return target as unknown as ClosestCapable;
}

/** Whether a pointer-up outside the focus card should clear Today ring focus. */
export function shouldDismissTodayFocusFromPointerTarget(target: EventTarget | null): boolean {
  const element = asClosestCapable(target);
  if (!element) return false;
  if (element.closest("[data-today-focus-card]")) return false;
  if (element.closest("[data-today-ring-focus-root]")) return false;
  if (element.closest("[data-top-entity-row]")) return false;
  return true;
}
